module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/bronze_medal.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/bronze_medal.png
// module id = 2033
// module chunks = 367